import axios from 'axios'
import {get} from 'lodash'

/**
 * @param {String} email
 * @param {Boolean} record - true to check an existing user, false otherwise
 *
 * @return {Promise<any>} -
 * where promise result is an object with error message (null if email is valid) and code
 * and data object if some information related to this email is known:
 * @see lookup-email-response-example.json
 * */
export function lookupEmail(email = '', record = true, teamOnly = false) {
    const lookup = {
        error: {
            message: null,
            code: null
        },
        data: null
    }
    return axios.get('lookup', {params: {email, record, teamOnly}})
        .then(res => {
            lookup.error.code = res.status
            if (res.status === 200) { // user/email exists
                if (record) {
                    lookup.error.message = 'An account already exists with that email.'
                } else if (res.data.sso_required) {
                    lookup.data = res.data
                }
            } else if (res.status === 201) {
                if (!record) {
                    lookup.error.message = 'User does not exist.'
                } else {
                    lookup.data = res.data
                }
            } else {
                lookup.error.message = 'Unknown error'
            }
            return lookup
        })
        .catch(err => {
            lookup.error.code = get(err, 'response.status')

            const data = get(err, 'response.data')
            if (data) {
                if (err.response.status === 400) {
                    if (data.error) {
                        lookup.error.message = data.error
                    } else {
                        lookup.error.message = 'Email invalid'
                    }
                } else if (data.errors && data.errors.email && data.errors.email[0]) {
                    lookup.error.message = data.errors.email[0]
                } else {
                    lookup.error.message = data
                }
            } else {
                lookup.error.message = 'Unknown error'
            }
            return lookup
        })
}
